<template>
  <section class="section" v-on:click="sectionClicked"
    :class="[currentWeather, dayNight]">
    <div class="bgTop" ref="section"></div><div class="bgBot">
      <div class="lb1"></div><div class="lb2"></div>
      <div class="lb3"></div><div class="lb4"></div>
      <div class="lb5"></div></div>
    <Header class="scrolled" ref="header" menu="teamUp"/>
    <div class="profileCnt">
      <div class="profileAct">
        <div class="score act sound act1" v-on:click="toggleSound"
          :class="{actRound: !loggedIn}">
          <img src="../assets/music.png" v-if="!audioMuted">
          <img src="../assets/mute.png" v-else>
        </div>
        <div class="score act act2 sound" v-on:click="openShare"
           v-if="loggedIn">
          <img src="../assets/sharing.png">
        </div>
        <div class="score act act3 sound" v-on:click="changeAcc"
           v-if="loggedIn">
          <img src="../assets/sprout.png">
        </div>
        <div class="score act sound" v-on:click="openHelp"
           v-if="loggedIn">
          <img src="../assets/help.png">
        </div>
        <div class="score act act4 sound" v-on:click="openInfo"
           v-if="loggedIn">
          <img src="../assets/info.png">
        </div>
        <div class="score act act2 sound" v-on:click="openLb"
           v-if="loggedIn" :class="{actLast: !myTree}">
          <img src="../assets/trophy-white.png">
        </div>
        <div class="score act act3 sound actLast" v-on:click="openTree"
          v-if="loggedIn && myTree">
          <div class="ntf ntfsm"></div>
          <img src="../assets/tree.png">
        </div>
        <div class="score act act3 sound" v-on:click="openInfo"
           v-if="loggedIn && 1>2">
          <img src="../assets/trees.png">
        </div>
      </div>
      <div class="divider"></div>
      <div class="profileAct profileActRight" v-if="loggedIn">
        <div class="score act sound act1 whiteBtn"
          v-on:click="openChat">
          <img src="../assets/chat.png">
          <div class="ntf" v-if="chatUnread > 0">
            {{chatUnread}}
          </div>
        </div>
      </div>
      <div class="expCnt" v-on:click="openLevel" v-if="loggedIn">
        <div class="ntf" v-if="unclaimedCount > 0">{{unclaimedCount}}</div>
        <h4 v-if="loadingPoint">...</h4>
        <h4 v-else>
          {{point.toLocaleString('id')}}pt
          <span class="streak" v-if="streak > 0"
            v-on:click.stop="openStreakInfo">{{streak}}</span>
        </h4>
        <div class="expLabel">dari 1.400pt</div>
        <div class="theExp">
          <div class="exp" :style="{width: `${point / 1400 * 100}%`}"></div>
        </div>
      </div>
      <transition name="fade">
        <div class="walkthrough acc" v-if="walkthrough === 'acc'">
          Pilih pot untuk pohonmu.
          <div class="wtAct">
            <button class="secondary" v-on:click="walkthrough = null">OK</button>
          </div>
        </div>
      </transition>
      <div class="walkthrough point" v-if="walkthrough === 'point'">
        Jumlah total poinmu. Tukarkan poin untuk mendapatkan aksesori
        untuk menghias pohon.
        <div class="wtAct">
          <button class="secondary" v-on:click="walkthrough = 'acc'">OK</button>
        </div>
      </div>
    </div>
    <div class="charCnt">
      <div class="theChar" :class="{locked: !loggedIn}">
        <div class="charImg" :class="charLvl"></div>
        <div class="bodyCnt" :class="accBot">
          <div class="body pot1"></div><div class="body pot2"></div>
          <div class="body pot3"></div><div class="body pot4"></div>
        </div>
      </div>
    </div>
    <div class="missionCnt" :class="{active: missionActive, open: missionOpen}">
      <div class="cnt">
        <div class="missionOverlay" v-on:click.stop="closeMission"
          :class="{open: missionOpen}"></div>
        <div class="blogCnt" v-on:click.stop="openMission">
          <div class="blogHandle" v-on:click.stop="toggleMission"></div>
          <div class="blogInfo">
            <div class="blogInfoIn">
              <h2>Team Up For Impact <span>Everyday</span></h2>
              <p>Lakukan challenge pilihanmu setiap hari dan kumpulkan poinnya.</p>
            </div>
          </div>
          <div class="missionSc" ref="missionSc"
            :class="{categoryOpen: selectedCategory}">
            <template v-if="!selectedCategory">
              <div class="chOfTheDay"
                :class="{signed: chOfTheDay.items.joined}">
                <div class="content" :style="{'background-color': chOfTheDay.items.color}"
                  v-on:click="joinChOfTheDay('thumb')">
                  <div class="text-content">
                    Challenge of the Day
                  </div>
                  <div class="img-content"
                    :style="{'background-image': `url(${chOfTheDay.items.media.imageSm})`}">
                  </div>
                </div>
                <div class="desc">
                  <div class="left-desc">
                    <div class="title">{{ chOfTheDay.items.name }}</div>
                    <div class="sub-title">
                      {{ chOfTheDay.signerCount }} orang mengikuti challenge ini.
                    </div>
                  </div>
                  <div class="right-desc">
                    <button class="joined" v-if="chOfTheDay.items.joined">
                      Diikuti
                    </button>
                    <button :style="{
                      'background-color': chOfTheDay.items.color,
                      'border-color': chOfTheDay.items.color
                      }" v-on:click="joinChOfTheDay('button')"
                      v-else>
                      Ikuti<span> Challenge</span>
                    </button>
                  </div>
                </div>
              </div>
              <template v-if="loadingRecomendation || recomendations.length > 0">
                <h4 class="chSectionTitle">Rekomendasi Hari Ini</h4>
                <div class="recomendations loadingData" v-if="loadingRecomendation">
                  <div class="recomendation" v-for="i in 8" :key="`rc${i}`"></div>
                </div>
                <div class="recomendations">
                  <div class="recomendation" v-for="(item, i) in recomendations" :key="i"
                    :style="{'background-color': item.color}"
                    :class="{signed: item.joined}"
                    v-on:click.stop="joinNow(item)">
                    <div class="recImg"
                      :class="[`recImg-${item.media.id}`]"
                      :style="{'background-image':
                      `url(${item.media.imageSm.replace('://demoapi.', '://api.')})`}"></div>
                    {{item.name}}
                  </div>
                </div>
              </template>
              <h4 class="chSectionTitle">Berdasarkan Kategori</h4>
            </template>
            <div class="selectedCategory" v-if="selectedCategory">
              <div class="btnBack" v-on:click.stop="doBack"></div>
              <h4>{{selectedCategory.name}}</h4>
            </div>
            <div class="blogContent" :class="{categoryOpen: selectedCategory}">
              <template v-if="!selectedCategory">
                <div class="theBlog loadingData" v-if="loadingCategory">
                  <div class="theBlogScCnt">
                    <div class="theBlogSc">
                      <div class="blogItem" v-for="i in 6" :key="i">
                        <div class="itemIn"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="theBlog notFound" v-else-if="!categories || categories.length < 1">
                  <img src="../assets/folder-locked.png">
                  <h4>Belum ada aksi bersama yang bisa diikuti</h4>
                </div>
                <div class="theBlog" v-else>
                  <div class="theBlogScCnt">
                    <div class="theBlogSc">
                      <div class="blogItem category" v-for="(item, i) in categories" :key="i">
                        <div class="itemIn" :style="{'background-color': item.color}"
                          :class="{signed: item.joined}"
                          v-on:click.stop="openCategory(item)">
                          <h4>{{item.name}}</h4>
                          <div class="blogImg" v-if="item.media"
                            :style="{'background-image':
                            `url(${item.media.imageSm.replace('://demoapi.', '://api.')})`}"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="theBlog loadingData" v-if="loading">
                  <div class="theBlogScCnt">
                    <div class="recomendations loadingData">
                      <div class="recomendation" v-for="i in 7" :key="i"></div>
                    </div>
                  </div>
                </div>
                <div class="theBlog notFound" v-else-if="!teamUp || teamUp.length < 1">
                  <img src="../assets/folder-locked.png">
                  <h4>Belum ada aksi bersama yang bisa diikuti</h4>
                </div>
                <div class="theBlog" v-else>
                  <div class="theBlogScCnt">
                    <div class="recomendations">
                      <div class="recomendation" v-for="(item, i) in teamUp" :key="i"
                        :style="{'background-color': item.color}"
                        :class="{signed: item.joined}"
                        v-on:click.stop="joinNow(item)">
                        <div class="recImg"
                          :class="[`recImg-${item.media.id}`]"
                          :style="{'background-image':
                          `url(${item.media.imageSm.replace('://demoapi.', '://api.')})`}"></div>
                        {{item.name}}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <svg id="inner">
      <defs>
        <!-- eslint-disable-next-line -->
        <path id="leaf" d="M41.9,56.3l0.1-2.5c0,0,4.6-1.2,5.6-2.2c1-1,3.6-13,12-15.6c9.7-3.1,19.9-2,26.1-2.1c2.7,0-10,23.9-20.5,25 c-7.5,0.8-17.2-5.1-17.2-5.1L41.9,56.3z"/>
      </defs>
      <g id="innerRainHolder"></g>
    </svg>
    <transition name="fade">
      <div class="walkthrough tree" v-if="walkthrough === 'tree'">
        Ini adalah pohonmu. Pohon ini akan tumbuh tinggi seiring
        dengan bertambahnya poinmu.
        <div class="wtAct">
          <button class="secondary" v-on:click="walkthrough = 'mission'">OK</button>
        </div>
      </div>
    </transition>
    <div class="walkthrough mission" v-if="walkthrough === 'mission'">
      Klik untuk mengikuti misi hari ini.
      <div class="wtAct">
        <button class="secondary" v-on:click="walkthrough = 'point'">OK</button>
      </div>
    </div>

    <Welcome ref="welcome"/>
    <ShareDialog ref="shareDialog"/>
    <ChangeAcc ref="changeAcc"/>
    <Level ref="level" :muted="audioMuted" v-on:toggleSound="toggleSound"
      v-on:share="openShare" v-on:changeAcc="changeAcc" v-on:help="openHelp"
      v-on:info="openInfo" v-on:leaderboard="openLb" v-on:tree="openTree"/>
    <TeamUp ref="teamUp"/>
    <Help ref="helpDialog"/>
    <Confetti ref="confetti"/>
    <Leaderboard ref="leaderboard"/>
    <Tree ref="tree"/>
    <ChatGroup ref="chatGroup"/>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Welcome from '@/components/Welcome.vue';
import ShareDialog from '@/components/ShareDialog.vue';
import ChangeAcc from '@/components/ChangeAcc.vue';
import Level from '@/components/Level.vue';
import TeamUp from '@/components/TeamUp.vue';
import Help from '@/components/Help.vue';
import Confetti from '@/components/Confetti.vue';
import Leaderboard from '@/components/Leaderboard.vue';
import Tree from '@/components/Tree.vue';
import ChatGroup from '@/components/ChatGroup.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: {
    Header,
    Welcome,
    ShareDialog,
    ChangeAcc,
    Level,
    TeamUp,
    Help,
    Confetti,
    Leaderboard,
    Tree,
    ChatGroup,
    Confirmation,
  },
  data() {
    return {
      charLvl: 'none',
      accBot: 'none',
      loadingPoint: true,
      point: 0,
      streak: 0,
      missionJoined: 0,
      unclaimedCount: 0,
      missionOpen: false,
      missionActive: false,
      loggedIn: false,
      walkthrough: null,
      dayNight: 'day',
      initialized: false,
      chatUnread: 0,

      /**
       * Challenge item
       *
       */
      loading: true,
      teamUp: [],
      teamUpIndex: 0,
      canGoNext: true,

      /**
       * Recomendations
       *
       */
      recomendations: [],
      loadingRecomendation: true,

      /**
       * Animation
       *
       */
      tickCount: 0,
      rain: [],
      leafs: [],
      settings: {
        renewCheck: 10,
        rainCount: 15,
        leafCount: 5,
      },
      leaf: null,
      currentWeather: 'wind',
      innerSVG: null,
      outerLeafHolder: null,
      innerRainHolder: null,
      myTree: null,

      /**
       * Category
       *
       */
      selectedCategory: false,
      loadingCategory: true,
      categories: [],

      /**
       * Audio
       *
       */
      audioMuted: false,
      ts: null,
      rs: null,
      dan: null,
      day: null,
      nig: null,

      /**
       * Challenge of The Day
       *
       */
      chOfTheDay: {
        items: {
          name: '',
          media: {},
        },
        signerCount: 0,
      },

      /**
       * Analytic
       *
       */
      scAlTimer: null,
    };
  },
  methods: {
    doNothing() {},
    openStreakInfo() {
      this.$refs.confirmDialog.open({
        title: `Kamu Sedang Streak ${this.streak} Hari`,
        desc: `Jika kamu mengikuti challenge berturut setiap hari maka
          kamu akan mendapatkan streak dan point tambahan.`,
        confirm: false,
        action: 'Tutup',
      });
    },
    openChat() {
      this.chatUnread = 0;
      this.$refs.chatGroup.open();
    },
    doBack() {
      this.selectedCategory = null;
      setTimeout(() => {
        this.$refs.missionSc.scrollTo(0, this.$refs.missionSc.scrollHeight);
      }, 50);
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    openLb() {
      this.$refs.leaderboard.open();
      this.$emit('fireal', 'open_leaderboard', 'teamup_everyday');
    },
    openTree() {
      this.$refs.tree.open(true, this.myTree);
      this.$emit('fireal', 'open_tree_detail', 'teamup_everyday');
    },
    openInfo() {
      this.$refs.welcome.open();
      this.$emit('fireal', 'open_info', 'teamup_everyday');
    },
    openHelp() {
      this.$refs.helpDialog.open();
    },
    toggleMission() {
      if (this.missionOpen) this.closeMission();
      else this.openMission();
    },
    openMission() {
      this.$emit('fireal', 'open_mission', 'teamup_everyday');
      this.missionOpen = true;
      if (this.walkthrough === 'mission') {
        this.walkthrough = 'point';
      }
    },
    closeMission() {
      this.missionOpen = false;
    },
    openShare() {
      this.$refs.shareDialog.open();
      this.$emit('fireal', 'open_share', 'teamup_everyday');
    },
    openLevel() {
      this.$emit('fireal', 'open_profile', 'teamup_everyday');
      this.$refs.level.open();
      if (this.walkthrough === 'point') {
        this.walkthrough = 'acc';
      }
    },
    changeAcc() {
      this.$emit('fireal', 'open_vase_selector', 'teamup_everyday');
      this.$refs.changeAcc.open(null, (b, accBot) => {
        this.accBot = this.$session.get('tufi2_acc_bot') || 'pot1';
      });
      if (this.walkthrough === 'acc') {
        this.walkthrough = null;
      }
    },
    joinChOfTheDay(from) {
      if (!this.loggedIn) {
        this.$refs.header.login({ from: 'game' });
        return;
      }
      this.$emit('fireal', 'join_challenge_of_the_day', 'teamup_everyday', { from });
      this.doJoinChallenge(this.chOfTheDay.items);
    },
    joinNow(item) {
      if (!this.loggedIn) {
        this.$refs.header.login({ from: 'game' });
        return;
      }
      this.$emit('fireal', 'join_challenge', 'teamup_everyday', {
        id: item.id,
        name: item.name,
      });
      this.doJoinChallenge(item);
    },
    doJoinChallenge(item) {
      this.$refs.teamUp.open({ d: item, canJoin: this.missionJoined < 3 }, () => {
        this.syncPoint();
      });
    },
    openCategory(item) {
      this.$emit('fireal', 'open_category', 'teamup_everyday', {
        id: item.id,
        name: item.name,
      });
      this.selectedCategory = item;
      this.getData();
    },
    getRecomendations() {
      this.loadingRecomendation = true;
      this.$http.get(this.$config.uri('challenge/recomendations')).then((r) => {
        this.loadingRecomendation = false;
        this.recomendations = r.data.status === 200 ? r.data.data : [];
      });
    },
    getCategories() {
      this.loadingCategory = true;
      this.$http.get(this.$config.uri('challenge/categories')).then((r) => {
        this.loadingCategory = false;
        this.categories = (r.data.status === 200) ? r.data.data : [];
      });
    },
    getData() {
      if (!this.selectedCategory) return;
      this.loading = true;
      const userId = localStorage.getItem('_tufi_u_id') || '';
      const catId = this.selectedCategory.id;
      const itemUri = `challenge/items?category=${catId}&_u=${userId}`;
      this.$http.get(this.$config.uri(itemUri)).then((r) => {
        this.teamUp = (r.data.status === 200) ? r.data.data : [];
        this.loading = false;
      });
    },
    startLightningTimer() {
      if (lightningTimeout) clearTimeout(lightningTimeout);
      if (this.currentWeather === 'rain') {
        lightningTimeout = setTimeout(() => {
          this.lightning();
        }, Math.random() * 10000);
      }
    },
    lightning() {
      this.startLightningTimer();
      if (this.currentWeather !== 'rain') return;
      if (this.ts && this.missionActive && !this.audioMuted) {
        this.ts.pause();
        this.ts.currentTime = 0;
        this.ts.volume = Math.random();
        if (this.ts.volume > 0.5) this.ts.volume = 0.5;
        this.ts.play();
      }
      TweenMax.fromTo(this.$refs.section, 0.75, { y: -30 }, { y: 0, ease: Elastic.easeOut });
      const pathX = 30 + Math.random() * (window.innerWidth - 60);
      const yOffset = 20;
      const steps = 20;
      const points = [`${pathX},0`];
      // eslint-disable-next-line
      for (var i = 0; i < steps; i++) {
        const x = pathX + (Math.random() * yOffset - (yOffset / 2));
        const y = (window.innerHeight / steps) * (i + 1);
        points.push(`${x},${y}`);
      }
      let strike = this.innerRainHolder.path(`M${points.join(' ')}`).attr({
        fill: 'none',
        stroke: 'white',
        strokeWidth: 2 + Math.random(),
      });
      TweenMax.to(strike.node, 1, {
        opacity: 0,
        ease: Power4.easeOut,
        onComplete: () => {
          strike.remove();
          strike = null;
        },
      });
    },
    makeRain() {
      const lineWidth = Math.random() * 3;
      const lineLength = 14;
      const x = Math.random() * (window.innerWidth - 40) + 20;
      const line = this.innerRainHolder.path(`M0,0 0,${lineLength}`).attr({
        fill: 'none',
        stroke: '#ffffff',
        strokeWidth: lineWidth,
      });
      this.rain.push(line);
      TweenMax.fromTo(line.node, 1, { x, y: 0 - lineLength },
        {
          delay: Math.random(),
          y: window.innerHeight,
          ease: Power2.easeIn,
          onComplete: (l, width, x2, type) => {
            l.remove();
            // eslint-disable-next-line
            l = null;
            // eslint-disable-next-line
            for (let i in this.rain) {
              if (!this.rain[i].paper) this.rain.splice(i, 1);
            }
            if (this.rain.length < this.settings.rainCount
              && this.currentWeather === 'rain') {
              this.makeRain();
            }
          },
          onCompleteParams: [line, lineWidth, x],
        });
    },
    makeLeaf() {
      const scale = 0.5 + (Math.random() * 0.5);
      const areaY = window.innerHeight / 2;
      const y = areaY + (Math.random() * areaY);
      const endY = y - ((Math.random() * (areaY * 2)) - areaY);
      const colors = ['#76993E', '#4A5E23', '#6D632F'];
      const color = colors[Math.floor(Math.random() * colors.length)];
      const newLeaf = this.leaf.clone().appendTo(this.outerLeafHolder).attr({
        fill: color,
      });
      const x = -(Math.floor(Math.random() * 1000) + 100);
      const xBezier = window.innerWidth / 10;
      const endX = window.innerWidth + 50;
      this.leafs.push(newLeaf);
      const bezier = [{ x, y },
        { x: xBezier, y: (Math.random() * endY) + (endY / 3) },
        { x: endX, y: endY },
      ];
      TweenMax.fromTo(newLeaf.node, Math.floor(Math.random() * 10) + 4,
        {
          rotation: Math.random() * 180, x, y, scale,
        },
        {
          rotation: Math.random() * 720,
          bezier,
          onComplete: (leaf) => {
            leaf.remove();
            // eslint-disable-next-line
            leaf = null;
            // eslint-disable-next-line
            for (var i in this.leafs) {
              if (!this.leafs[i].paper) this.leafs.splice(i, 1);
            }
            if (this.leafs.length < this.settings.leafCount
              && this.currentWeather === 'wind' && this.dayNight === 'day') {
              this.makeLeaf();
            }
          },
          onCompleteParams: [newLeaf],
          ease: Power0.easeIn,
        });
    },
    tick() {
      this.tickCount += 1;
      const check = this.tickCount % this.settings.renewCheck;
      if (check) {
        if (this.rain.length < this.settings.rainCount
          && this.currentWeather === 'rain') {
          this.makeRain();
        }
        if (this.leafs.length < this.settings.leafCount
          && this.currentWeather === 'wind' && this.dayNight === 'day') {
          this.makeLeaf();
        }
      }
      requestAnimationFrame(this.tick);
    },
    calcLvl() {
      if (this.point >= 800) this.charLvl = 'lv5';
      else if (this.point >= 600) this.charLvl = 'lv4';
      else if (this.point >= 400) this.charLvl = 'lv3';
      else if (this.point >= 200) this.charLvl = 'lv2';
      else this.charLvl = 'lv1';
    },
    syncPoint() {
      this.calcLvl();
      this.loadingPoint = true;
      this.$http.get(this.$config.uri('user/point')).then((r) => {
        this.loadingPoint = false;
        if (r.data.status !== 200) return;
        this.point = r.data.point || 0;
        this.streak = r.data.streak || 0;
        this.missionJoined = r.data.missionJoined || 0;
        this.$session.set('tufi2_point', this.point);
        this.calcLvl();
        if (this.point >= 1400 && localStorage.getItem('tufi2_finished') !== 'y') {
          localStorage.setItem('tufi2_finished', 'y');
          this.$refs.confetti.open();
        }
      });
    },
    toggleSound() {
      if (this.audioMuted) {
        this.audioMuted = false;
        localStorage.setItem('audioMuted', 'n');
        this.playAudio();
        this.$emit('fireal', 'sound_on', 'teamup_everyday');
      } else {
        this.audioMuted = true;
        localStorage.setItem('audioMuted', 'y');
        if (this.ts) this.ts.pause();
        if (this.rs) this.rs.pause();
        if (this.dan) this.dan.pause();
        if (this.day) this.day.pause();
        if (this.nig) this.nig.pause();
        this.$emit('fireal', 'sound_off', 'teamup_everyday');
      }
    },
    stopAudio() {
      if (this.ts) this.ts.pause();
      if (this.rs) this.rs.pause();
      if (this.dan) this.dan.pause();
      if (this.day) this.day.pause();
      if (this.nig) this.nig.pause();
    },
    playAudio() {
      if (this.audioMuted) return;
      if (this.currentWeather === 'rain') {
        if (this.rs && this.missionActive) {
          this.rs.pause();
          this.rs.currentTime = 0;
          this.rs.play();
        }
      } else if (this.dayNight === 'day') {
        if (this.dan) this.dan.play();
        if (this.day) this.day.play();
      } else if (this.dayNight === 'night') {
        if (this.nig) this.nig.play();
      }
    },
    countChat() {
      this.$http.get(this.$config.uri('group/unread')).then((r) => {
        this.chatUnread = (r.data.status === 200) ? r.data.unreadCount : 0;
      });
    },

    /**
     * Analytic
     *
     */
    fireAlEvent(convId) {
      this.$emit('fireal', 'page_visit', 'teamup_everyday', null, convId, (r) => {
        if (r.data.status !== 200) return;
        alTimer = setTimeout(() => {
          this.fireAlEvent(r.data.id);
        }, 5000);
      });
    },
  },
  computed: {},
  beforeDestroy() {
    this.stopAudio();
    if (lightningTimeout) clearTimeout(lightningTimeout);
    document.body.classList.remove('hidefooter');
  },
  created() {
    document.body.classList.add('hidefooter');
  },
  mounted() {
    document.title = 'Team Up Everyday - Team Up For Impact';

    this.initialized = true;
    if (lightningTimeout) clearTimeout(lightningTimeout);

    /**
     * Get challenge of the day
     *
     */
    this.$http.get(this.$config.uri('challenge/challengeOfTheDay')).then((response) => {
      this.chOfTheDay.items = response.data.data;

      // get signer count
      const url = this.$config.uri(
        `challenge/item/${this.chOfTheDay.items.id}/signerCount`,
      );
      this.$http.get(url).then((resp) => {
        this.chOfTheDay.signerCount = resp.data.count;
      });
    });


    /**
     * Chat Group
     *
     */
    this.$socket.emit('sign', {
      key: this.$config.apiKey,
      token: this.$session.get('tufi2_jwt'),
    });
    this.sockets.unsubscribe('broadcast');
    this.sockets.subscribe('broadcast', (msg) => {
      this.chatUnread += 1;
    });
    this.countChat();

    /**
     * Analytic
     *
     */
    this.fireAlEvent();

    /**
     * Get challenges data
     *
     */
    this.getCategories();
    this.getRecomendations();

    this.audioMuted = localStorage.getItem('audioMuted') === 'y';
    this.$http.get(this.$config.uri('user/price/unclaimed/count')).then((r) => {
      this.unclaimedCount = (r.data.status === 200) ? r.data.total : 0;
    });

    this.$http.get(this.$config.uri('user/tree/my')).then((r) => {
      this.myTree = (r.data.status === 200) ? r.data.data : 0;
    });

    /**
     * Day night changes
     *
     */
    clearInterval(dayNightTimer);
    dayNightTimer = setInterval(() => {
      this.dayNight = (this.dayNight === 'day') ? 'night' : 'day';
      /* eslint-disable */
      if (!this.audioMuted && this.missionActive) {
        if (this.dayNight === 'day') {
          if (this.currentWeather === 'wind') {
            if (this.dan) this.dan.play();
            if (this.day) this.day.play();
          }
          if (this.nig) this.nig.pause();
        } else {
          if (this.currentWeather === 'wind') {
            if (this.nig) this.nig.play();
          }
          if (this.dan) this.dan.pause();
          if (this.day) this.day.pause();
        }
      }
      /* eslint-enable */
    }, 30000);


    /**
     * Weather changer
     *
     */
    clearInterval(iddleTimer);
    iddleTimer = setInterval(() => {
      const x = Math.floor(Math.random() * 3);
      this.currentWeather = (x === 2) ? 'rain' : 'wind';
      if (this.currentWeather === 'rain') {
        if (!this.audioMuted) {
          if (this.rs && this.missionActive) {
            this.rs.pause();
            this.rs.currentTime = 0;
            this.rs.play();
          }
          if (this.dan) this.dan.pause();
          if (this.day) this.day.pause();
          if (this.nig) this.nig.pause();
        }
        this.startLightningTimer();
      } else if (!this.audioMuted) {
        /* eslint-disable */
        if (this.rs) this.rs.pause();
        if (this.missionActive) {
          if (this.dayNight === 'day') {
            if (this.dan) this.dan.play();
            if (this.day) this.day.play();
          } else {
            if (this.nig) this.nig.play();
          }
        }
        /* eslint-enable */
      }
    }, 15000);

    /**
     * Start awesome animation
     *
     */
    this.ts = new Audio(`${this.$config.cdnUri}media/audio/thunder.mp3`);
    this.rs = new Audio(`${this.$config.cdnUri}media/audio/Hujan_High.mp3`);
    this.rs.volume = 1;
    this.dan = new Audio(`${this.$config.cdnUri}media/audio/Siang_Animal.mp3`);
    this.dan.volume = 1;
    this.day = new Audio(`${this.$config.cdnUri}media/audio/Siang_Cerah_High.mp3`);
    this.day.volume = 0.4;
    this.nig = new Audio(`${this.$config.cdnUri}media/audio/Malam_Cerah_High.mp3`);
    this.nig.volume = 1;
    setTimeout(() => {
      this.leaf = Snap.select('#leaf');
      this.innerSVG = Snap('#inner');
      this.outerLeafHolder = this.innerSVG.group();
      this.innerRainHolder = Snap('#innerRainHolder');
      requestAnimationFrame(this.tick);
    });

    /**
     * Init Game
     *
     */
    this.accBot = this.$session.get('tufi2_acc_bot') || 'pot1';
    this.charLvl = this.$session.get('tufi2_g_lvl') || 'lv1';
    this.point = this.$session.get('tufi2_point') || 0;
    this.syncPoint();

    /**
     * Check login
     *
     */
    this.loggedIn = (this.$session.get('tufi2_jwt'));
    if (localStorage.getItem('tufi2_welcome') && this.$session.get('tufi2_jwt')) {
      /**
       * Display welcome message
       *
       */
      this.$refs.welcome.open({ ok: true }, () => {
        this.walkthrough = (localStorage.getItem('tufi2_walkthrough')) ? null : 'tree';
        localStorage.setItem('tufi2_walkthrough', '127st8');
        this.playAudio();
        setTimeout(() => {
          this.missionActive = true;
        });
      });
    } else {
      this.$refs.welcome.open(null, () => {
        if (!this.$session.get('tufi2_jwt')) {
          this.$refs.header.login({ from: 'game' }, () => {
            setTimeout(() => {
              this.missionActive = true;
            });
          });
        } else {
          setTimeout(() => {
            this.missionActive = true;
          });
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
#inner{
  z-index: 991;
  position: fixed; pointer-events: none;
  left: 0; top: 60px; width: 100%; height: 100%;
}

.walkthrough{
  position: absolute;
  background-color: #ffc957;
  padding: 14px 20px;
  border-radius: 5px;
  width: 260px;
  font-size: 14px;
  z-index: 997;
  box-sizing: border-box;
  .wtAct{
    text-align: right;
    button{
      padding: 4px 0 0;
      font-size: 13px;
      border: none;
      box-shadow: none;
      background-color: #ffc957;
    }
  }
  &:before{
    content: "";
    position: absolute;
    bottom: -10px; left: 50%;
    margin-left: -10px;
    border-top: #ffc957 10px solid;
    border-left: transparent 10px solid;
    border-right: transparent 10px solid;
  }
  &.tree{
    left: 50%; bottom: 340px;
    margin-left: -130px;
  }
  &.mission{
    left: 50%; bottom: 120px;
    margin-left: -130px;
  }
  &.point{
    right: 10px; top: 96px;
    @media (max-width: 1024px) {
      top: 84px; right: 6px;
    }
    &:before{
      left: auto; right: 40px;
      bottom: auto;
      top: -10px;
      border-top: none;
      border-bottom: #ffc957 10px solid;
    }
  }
  &.acc{
    left: 110px; top: 96px;
    @media (max-width: 1024px) {
      left: 80px; top: 84px;
    }
    @media (max-width: 680px) {
      left: 74px; top: 185px;
    }
    &:before{
      left: 50px;
      bottom: auto;
      top: -10px;
      border-top: none;
      border-bottom: #ffc957 10px solid;
      @media (max-width: 680px) {
        left: 0; top: 20px;
        border-bottom: transparent 10px solid;
        border-right: #ffc957 10px solid;
        border-top: transparent 10px solid;
        border-left: none;
      }
    }
  }
}

.section{
  padding: 0 10px 40px;
  position: fixed;
  overflow: auto;
  left: 0; top: 60px; right: 0; bottom: 0;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-color: #fff;
  overflow: hidden;
  &.rain{
    .bgTop, .bgBot{
      filter: grayscale(0.1) brightness(0.8);
    }
  }
  &.night{
    .bgTop, .bgBot{
      filter: grayscale(0.5) brightness(0.4);
    }
    .theChar{
      filter: grayscale(0.2) brightness(0.6);
    }
  }
  .bgTop, .bgBot{
    position: absolute;
    left: 0; right: 0;
    background-size: auto 100%;
    background-repeat: no-repeat;
    transition: filter .7s ease;
  }
  .bgTop{
    z-index: 3;
    top: -40px; height: 100%;
    @media (max-width: 680px) {
      top: -20px;
    }
    &:before{
      content: "";
      position: absolute;
      left: 0; top: 0; right: 0;
      height: 300px;
      background-image: url(../assets/Atas-Kiri.svg);
      background-size: contain;
      background-position: left top;
      background-repeat: no-repeat;
      @media (max-width: 1480px) {
        height: 260px;
      }
      @media (max-width: 680px) {
        height: 300px;
      }
    }
    &:after{
      content: "";
      position: absolute;
      left: 0; top: 0; right: 0;
      height: 300px;
      background-image: url(../assets/Atas-Kanan.svg);
      background-size: contain;
      background-position: right top;
      background-repeat: no-repeat;
      @media (max-width: 1480px) {
        height: 260px;
      }
      @media (max-width: 680px) {
        height: 300px;
      }
    }
  }
  .bgBot{
    bottom: 0; height: 300px;
    background-image: url(../assets/bg-bot.png);
    background-position: bottom center;

    background-image: url(../assets/BG.jpg);
    height: 100%;
    .lb1{
      position: absolute;
      left: 0; bottom: 0; right: 0;
      height: 600px;
      background-image: url(../assets/FG-Kiri-2.svg);
      background-size: contain;
      background-position: bottom left;
      background-repeat: no-repeat;
      z-index: 3;
      @media (max-width: 1480px) {
        height: 400px;
      }
      @media (max-width: 960px) {
        bottom: 80px; height: 240px;
      }
      @media (max-width: 680px) {
        height: 140px;
      }
    }
    .lb2{
      position: absolute;
      left: 0; bottom: 0; right: 0;
      height: 600px;
      background-image: url(../assets/FG-Kanan-2.svg);
      background-size: contain;
      background-position: bottom right;
      background-repeat: no-repeat;
      z-index: 3;
      @media (max-width: 1480px) {
        height: 400px;
      }
      @media (max-width: 960px) {
        bottom: 80px; height: 240px;
      }
      @media (max-width: 680px) {
        height: 140px;
      }
    }
    .lb3{
      position: absolute;
      left: 0; bottom: 80px;
      height: 360px; width: 360px;
      background-image: url(../assets/FG-Kiri-1.svg);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transform-origin: bottom;
      animation: windAn1 10s infinite ease;
      @media (max-width: 1480px) {
        height: 240px; width: 240px;
      }
      @media (max-width: 680px) {
        width: 120px; height: 120px; bottom: 86px;
      }
    }
    .lb4{
      position: absolute;
      right: 0; bottom: 80px;
      height: 340px; width: 340px;
      background-image: url(../assets/FG-Kanan-3.svg);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transform-origin: bottom;
      animation: windAn2 10s infinite ease;
      @media (max-width: 1480px) {
        height: 220px; width: 220px;
        bottom: 60px;
      }
      @media (max-width: 680px) {
        display: none;
      }
    }
    .lb5{
      position: absolute;
      right: 320px; bottom: 80px;
      height: 180px; width: 180px;
      background-image: url(../assets/FG-Kanan-1.svg);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transform-origin: bottom;
      animation: windAn1 10s infinite ease;
      @media (max-width: 1090px) {
        right: 200px;
      }
      @media (max-width: 960px) {
        width: 140px; height: 140px;
        right: 180px;
      }
      @media (max-width: 720px) {
        display: none;
      }
      @media (max-width: 680px) {
        display: block;
        right: 0; width: 120px; height: 120px;
      }
    }
  }
}
.profileCnt{
  padding: 20px 10px 0;
  display: flex;
  align-items: center;
  transition: all .3s ease;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 997;
  flex-wrap: wrap;
  @media (max-width: 1480px) {
    max-width: 1200px;
  }
  @media (max-width: 1280px) {
    max-width: none;
    margin: 0;
  }
  @media (max-width: 960px) {
    padding: 20px 6px 0;
  }
  @media (max-width: 760px) {
    flex-direction: column-reverse;
    margin: 0;
    margin-right: 60px;
    padding-left: 0;
    padding-right: 0;
  }
  .profileAct{
    display: flex;
    @media (max-width: 760px) {
      display: none;
    }
    &.profileActRight{
      @media (max-width: 760px) {
        display: block;
        position: absolute;
        right: -60px; top: 13px;
      }
      .score{
        @media (max-width: 760px) {
          margin: 0;
        }
      }
    }
  }
  .divider{
    margin: 0 auto;
  }
  .ntf{
    width: auto;
    min-width: 20px; height: 20px;
    border-radius: 10px;
    position: absolute;
    right: -2px; top: -2px;
    font-size: 13px;
    padding: 1px 5px 0;
    background-color: #f14724;
    box-sizing: border-box;
    color: #fff;
    text-align: center;
    font-weight: bold;
    &.ntfsm{
      min-width: 14px; height: 14px;
      right: -4px; top: -4px;
    }
  }
  .expCnt{
    background-color: #fff;
    border-radius: 10px;
    padding: 7px 16px 0;
    height: 50px;
    margin-left: 4px;
    box-sizing: border-box;
    position: relative;
    width: 280px;
    cursor: pointer;
    transition: all .3s ease;
    @media (max-width: 960px) {
      width: 240px;
      margin-top: -6px;
    }
    @media (max-width: 760px) {
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 20px;
      margin-left: 0;
    }
    .ntf{
      right: 100%; top: -4px;
      margin-right: -16px;
    }
    &:hover{
      background-color: #f5f5fe;
      box-shadow: 2px 2px 6px rgba(0,0,0,.2);
    }
    h4{
      margin: 0 0 4px;
      font-size: 16px;
      color: #5351a4;
      position: relative;
      display: inline-block;
      .streak{
        position: absolute;
        right: -32px; top: 0; bottom: 0;
        background-image: url(../assets/lighting.png);
        background-size: 20px auto;
        background-position: left center;
        background-repeat: no-repeat;
        padding-left: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fabe2c;
      }
    }
    .expLabel{
      position: absolute;
      right: 20px; top: 8px;
      font-size: 14px;
    }
    .theExp{
      height: 6px;
      background-color: #ddd;
      border-radius: 50px;
      .exp{
        height: 100%;
        max-width: 100%;
        background-color: #8EC642;
        // background-color: #6aa722;
        border-radius: 50px;
      }
    }
    .info{
      font-size: 12px;
      color: #555;
      text-align: right;
      margin: 5px 5px 0;
    }
  }
  .score{
    width: 60px; height: 60px;
    background-color: #5351a4;
    // border-radius: 50%;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding-top: 14px;
    box-sizing: border-box;
    // box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
    position: relative;
    transition: all .3s ease;
    cursor: pointer;
    color: #fff;
    border-radius: 10px;
    position: relative;
    &:before{
      position: absolute;
      content: "";
      left: 0; right: 0; top: 0; bottom: 0;
      background-color: rgba(255, 255, 255, .1);
      opacity: 0;
      border-radius: 10px;
      transition: all .3s ease;
    }
    .ntf{
      right: -6px; top: -6px;
      &.ntfsm{
        right: -4px; top: -4px;
      }
    }
    &.act1{
      border-radius: 5px 0 0 5px;
      &:before{
        border-radius: 5px 0 0 5px;
      }
    }
    &.actLast{
      border-radius: 0 5px 5px 0;
      &:before{
        border-radius: 0 5px 5px 0;
      }
    }
    &.actRound{
      border-radius: 5px;
      &:before{
        border-radius: 5px;
      }
    }
    &.act2{
      background-color: #fdbb30;
    }
    &.act3{
      background-color: #1c7e67;
    }
    &.act4{
      background-color: #f14722;
    }
    &.act5{
      background-color: #01b0b7;
    }
    &.act6{
      background-color: #fdbb30;
    }
    @media (max-width: 1024px) {
      width: 50px; height: 50px;
      padding-top: 12px;
    }
    @media (max-width: 760px) {
      margin-bottom: 6px;
    }
    &:hover{
      // background-color: #615fb1;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      &:before{
        opacity: 1;
      }
    }
    &.point{
      width: auto;
      white-space: nowrap;
      padding: 12px 26px 0;
      text-transform: uppercase;
      font-size: 26px;
      font-family: 'GolosUIWebBold', sans-serif;
      @media (max-width: 1024px) {
        font-size: 20px;
        padding: 12px 20px;
      }
      span{
        font-family: 'GolosUIWebRegular', sans-serif;
        opacity: .7;
        font-weight: lighter;
      }
    }
    &.sound{
      img{
        width: 24px;
        position: relative;
        z-index: 3;
        @media (max-width: 1024px) {
          width: 24px;
        }
      }
    }
    &.act{
      margin-right: 6px;
      border-radius: 10px;
      height: 50px; width: 50px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      &.whiteBtn{
        background-color: #fff;
        img{
          width: 28px;
        }
      }
    }
  }
}
.charCnt{
  .theChar{
    position: fixed;
    z-index: 3;
    left: 10px; right: 10px; top: 140px; bottom: 130px;
    transition: filter .7s ease;
    @media (max-width: 680px) {
      bottom: 140px; top: 180px;
    }
    .charImg{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-position: bottom center;
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 3;
      animation: breathing 7s linear forwards infinite;
      transform-origin: bottom;
      &.lv1{
        background-image: url(../assets/char/Lv1.png);
      }
      &.lv2{
        background-image: url(../assets/char/Lv2.png);
      }
      &.lv3{
        background-image: url(../assets/char/Lv3.png);
      }
      &.lv4{
        background-image: url(../assets/char/Lv4.png);
      }
      &.lv5{
        background-image: url(../assets/char/Lv5.png);
      }
    }
    .bodyCnt{
      .body{ visibility: hidden; }
      &.pot1{
        .body.pot1{ visibility: visible; }
      }
      &.pot2{
        .body.pot2{ visibility: visible; }
      }
      &.pot3{
        .body.pot3{ visibility: visible; }
      }
      &.pot4{
        .body.pot4{ visibility: visible; }
      }
    }
    .body{
      left: 0; right: 0; top: 0; bottom: 0;
      position: absolute;
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      &.pot1{
        background-image: url(../assets/char/Pot1.png);
      }
      &.pot2{
        background-image: url(../assets/char/Pot2.png);
      }
      &.pot3{
        background-image: url(../assets/char/Pot3.png);
      }
      &.pot4{
        background-image: url(../assets/char/Pot4.png);
      }
    }
    &.locked{
      .charImg{
        background-image: url(../assets/char/Tree-locked.png);
      }
      .bodyCnt{
        .body.pot1{
          visibility: visible;
          background-image: url(../assets/char/Pot-locked.png);
        }
      }
    }
  }
}

.missionCnt{
  position: absolute;
  left: 0; right: 0;
  z-index: 9997;
  transition: all .5s ease;
  bottom: -100%;
  height: calc(100vh - 80px);
  @media (max-width: 680px) {
    position: fixed;
    height: calc(100vh - 20px);;
  }
  &.active{
    bottom: calc(-100% + 140px);
  }
  &.open{
    bottom: 0;
  }
  .cnt{
    height: 100%;
    @media (max-width: 960px) {
      width: auto;
      margin: 0;
    }
  }
  .missionOverlay{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9991;
    visibility: hidden;
    opacity: 0;
    transition: all .3s ease;
    &.open{
      visibility: visible;
      opacity: 1;
    }
  }
  .blogCnt{
    background-color: #fff;
    width: 820px;
    height: 100%;
    border-radius: 10px 10px 0 0;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    z-index: 9992;
    @media (max-width: 960px) {
      width: 100%;
    }
    .blogHandle{
      cursor: pointer;
      position: absolute;
      left: 0; right: 0; top: 0;
      height: 30px;
      z-index: 7;
      &:before{
        content: "";
        height: 8px; width: 80px;
        border-radius: 50px;
        background-color: #ddd;
        margin: 11px auto 0;
        transition: all .3s ease;
        cursor: pointer;
        display: block;
      }
      &:hover{
        &:before{
          background-color: #ccc;
        }
      }
    }
    .missionSc{
      overflow: auto;
      height: calc(100% - 120px);
      border-top: #eee 1px solid;
      &.categoryOpen{
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .selectedCategory{
          height: 54px;
          padding: 0;
          box-sizing: border-box;
        }
        .blogContent{
          height: calc(100% - 54px);
          border-top: #eee 1px solid;
          box-sizing: border-box;
          overflow: auto;
          padding-top: 20px;
        }
      }
    }
    .blogInfo{
      text-align: center;
      z-index: 3;
      transition: all .3s ease;
      margin-top: 30px;
      padding: 0 20px;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      .blogInfoIn{
        width: 100%;
      }
      h2{
        color: #5351a4;
        font-family: 'GolosUIWebBold', sans-serif;
        margin: 0;
        font-size: 26px;
        @media (max-width: 960px) {
          font-size: 22px;
        }
        span{
          color: #f14724
        }
      }
      p{
        max-width: 960px;
        margin: 0 auto;
        font-size: 16px;
        color: #767676;
        @media (max-width: 960px) {
          font-size: 14px;
        }
      }
    }
    .blogContent{
      z-index: 2;
      transition: all .3s ease;
      &.categoryOpen{
        min-height: 330px;
      }
    }
    .selectedCategory{
      display: flex;
      align-items: center;
      padding: 10px 0 16px;
      width: 640px;
      margin: 0 auto;
      @media (max-width: 720px) {
        width: 100%;
        margin: 0 16px;
      }
      .btnBack{
        width: 36px; height: 36px;
        border-radius: 50%;
        background-image: url(../assets/arrow-back.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        margin-right: 12px;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: #f5f5f5;
        }
      }
      h4{
        margin: 0;
        color: #5351a4;
        font-family: 'GolosUIWebBold', sans-serif;
        font-size: 20px;
      }
    }
    .theBlog{
      transition: all .3s ease;
      padding: 0 0 60px;
      .theBlogScCnt{
        max-width: 640px;
        margin: 0 auto;
        @media (max-width: 720px) {
          max-width: none;
          margin: 0 16px;
        }
        .recomendations{
          margin: 0;
        }
      }
      .theBlogSc{
        display: flex;
        justify-content: center;
        // transition: all .7s ease;
        flex-wrap: wrap;
        margin: 0 -6px;
        padding: 0 0 8px;
        &.scList{
          display: block;
          margin: 0;
        }
        .blogItem{
          position: relative;
          // transition: all .3s ease;
          width: 33.333333%;
          box-sizing: border-box;
          padding: 0 6px;
          .itemIn{
            background-color: #eee;
            position: relative;
            width: 100%; height: 140px;
            margin: 0 0 12px;
            padding: 10px 12px;
            box-sizing: border-box;
            border-radius: 5px;
            color: #fff;
            cursor: pointer;
            transition: transform .3s ease;
            @media (max-width: 720px) {
              height: 26vw;
            }
            h4{
              margin: 0;
              line-height: 1.1;
              transition: all .3s ease;
              display: block;
              position: absolute;
              bottom: 10px; left: 20px;
              color: #fff;
              z-index: 991;
              font-weight: 600;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-family: 'GolosUIWebBold', sans-serif;
              font-size: 15px;
            }
            &:hover{
              transform: scale(1.04);
            }
          }
          .blogImg{
            position: absolute;
            transition: all .3s ease;
            left: 10px; bottom: 36px; right: 10px; top: 10px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.itemList{
            width: auto;
          }
        }
      }
      &.notFound{
        text-align: center;
        padding: 0 0 40px;
        h4{
          margin: 0;
          font-size: 14px;
          color: #767676;
          font-weight: normal;
        }
        img{
          width: 84px;
          opacity: .56;
          margin: 0;

          margin: 16px 0 14px;
          width: 64px;
        }
      }
      &.loadingData{
        .theBlogSc{
          .blogItem{
            .itemIn{
              background-color: #eee;
              transform: none !important;
              cursor: default;
            }
          }
        }
      }
    }
  }
  .chOfTheDay{
    margin: 20px auto;
    max-width: 640px;
    border-radius: 5px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    transition: all .3s ease;
    cursor: pointer;
    &:hover{
      transform: scale(1.02);
    }
    @media (max-width: 720px) {
      max-width: none;
      margin: 20px 16px;
    }
    &:before{
      content: "";
      position: absolute;
      right: 8px; top: 9px;
      width: 16px; height: 16px;
      background-size: 16px auto;
      z-index: 7;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../assets/checkmark-white.png);
      opacity: .3;
    }
    &.signed{
      &:before{
        opacity: 1;
      }
    }
    .content{
      padding: 0 60px;
      display: flex;
      align-items: center;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      height: 170px;
      box-sizing: border-box;
      position: relative;
      @media (max-width: 720px) {
        padding: 0 28px;
      }
      .text-content{
        color: #fff;
        font-size: 32px;
        font-weight: 400;
        max-width: 180px;
        font-family: 'GolosUIWebBold', sans-serif;
        line-height: 1.2;
        @media (max-width: 960px) {
          font-size: 25px;
        }
      }
      .img-content{
        position: absolute;
        right: 10px; bottom: 20px; top: 20px;
        width: 50%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .desc{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      @media (max-width: 960px) {
        padding: 8px 10px;
      }
      .left-desc{
        max-width: 360px;
        @media (max-width: 720px) {
          max-width: 230px;
        }
      }
      .title{
        font-size: 17px;
        font-weight: 600;
        font-family: 'GolosUIWebBold', sans-serif;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 960px) {
          font-size: 15px;
        }
      }
      .sub-title{
        color: #767676;
        font-size: 15px;
        @media (max-width: 960px) {
          font-size: 13px;
        }
      }

      button{
        border-radius: 50px;
        padding: 9px 22px 8px;
        font-size: 16px;
        text-transform: uppercase;
        transition: all .3s ease;
        &.joined{
          background-color: #eee;
          box-shadow: none;
          color: #999;
          border-color: #eee;
        }
        span{
          @media (max-width: 720px) {
            display: none;
          }
        }
        @media (max-width: 720px) {
          padding: 9px 20px 8px;
          font-size: 16px;
        }
      }
    }
  }

  .chSectionTitle{
    color: #5351a4;
    font-family: 'GolosUIWebBold', sans-serif;
    margin: 30px auto 10px;
    max-width: 640px;
    font-size: 20px;
    padding-left: 10px;
    @media (max-width: 720px) {
      max-width: none;
      margin: 30px 16px 10px;
    }
  }

  .recomendations{
    max-width: 640px;
    margin: 0 auto;
    padding-bottom: 10px;
    @media (max-width: 720px) {
      max-width: none;
      margin: 0 16px;
    }
    .recomendation{
      padding: 14px 34px;
      margin-bottom: 10px;
      border-radius: 5px;
      background-color: rgb(253, 187, 48);
      font-weight: 600;
      font-size: 18px;
      color: #fff;
      padding-left: 70px;
      position: relative;
      cursor: pointer;
      transition: all .3s ease;
      line-height: 1.06;
      &:hover{
        transform: scale(1.02);
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
      &:before{
        content: "";
        position: absolute;
        right: 8px; top: 9px;
        width: 16px; height: 16px;
        background-size: 16px auto;
        z-index: 7;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/checkmark-white.png);
        opacity: .3;
      }
      &.signed{
        &:before{
          opacity: 1;
        }
      }
      .recImg{
        position: absolute;
        left: 8px; top: 0;
        width: 52px; bottom: 0;
        border-radius: 5px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    &.loadingData{
      .recomendation{
        background-color: #eee;
        height: 52px;
        box-sizing: border-box;
        transform: none !important;
        cursor: default;
        &:before{
          display: none;
        }
      }
    }
  }
}

@keyframes windAn1 {
  0% {transform: rotate(0deg);}
  10% {transform: rotate(0deg);}
  45% {transform: rotate(10deg);}
  55% {transform: rotate(10deg);}
  90% {transform: rotate(0deg);}
  100% {transform: rotate(0deg);}
}
@keyframes windAn2 {
  0% {transform: rotate(0deg);}
  10% {transform: rotate(0deg);}
  45% {transform: rotate(8deg);}
  55% {transform: rotate(8deg);}
  90% {transform: rotate(0deg);}
  100% {transform: rotate(0deg);}
}
@keyframes breathing {
  0% {transform: scale(1);}
  25% {transform: scale(1.01);}
  50% {transform: scale(1.02);}
  75% {transform: scale(1.01);}
  100% {transform: scale(1);}
}
</style>
